import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import WelcomeIcon from '../../Images/MFILogo.png';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import TruckIcon from '../../Images/TruckIcon.png';
import CartonBox from '../../Images/CartonBox.png';
import PickNTrackPattern from '../../Images/PickNTrackPattern.png';
import CountUp from 'react-countup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeContext } from '../Common/ThemeProvider';
import {
    faTruck,
    faWarehouse, faMapMarkedAlt, faBoxOpen, faBell, faExclamationCircle, faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import Loader from '../Common/Loader';
import { GreetingMessage } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import moment from 'moment';

const Welcome = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Message, setMessage] = useState("");
    const [DashBoardCount, setDashBoardCount] = useState({});
    const [Loading, setLoading] = useState(false);
    const [PartnerAdminAlert, setPartnerAdminAlert] = useState({});
    const [LicensePopup, setLicensePopup] = useState(null);

    useEffect(() => {
        FetchDashBoardInfo();
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData.ExpiryDate !== undefined && userData.ExpiryDate !== "" && moment() < moment(userData.ExpiryDate)) {
            setLicensePopup(moment(userData.ExpiryDate).diff(moment(), 'days'))
        }
        else {
            setLicensePopup(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchDashBoardInfo = () => {
        setLoading(true);
        let message = GreetingMessage();
        setMessage(message);
        if (IsUndefinedNullOrEmpty(DashBoardCount.QuotationCount)) {
            var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
            if (!IsUndefinedNullOrEmpty(userData) && userData.Role.length > 0 && userData.Role[0].Name.toUpperCase() === "ADMIN") {
                Axiosfetch(baseURL + "GetDashBoardCounts", "GET", null, getDashBorrdData, Failure);
            }
            else if (!IsUndefinedNullOrEmpty(userData)) {
                Axiosfetch(baseURL + "GetDashBoardCountsByOrgID", "POST", { OrgID: userData.OrganizationID }, getDashBorrdData, Failure);
            }
        }
    };

    const FetchAlertInfo = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetLatestAlertByPartnerID", "POST", { Date: new Date(), EndDate: Date, PartnerID: userData.OrganizationID }, AlertSuccess, Failure);
    };

    const AlertSuccess = (data) => {
        if (data.length > 0) {
            setPartnerAdminAlert(data[0]);
        }
        else {
            setPartnerAdminAlert({});
        }
    }

    const getDashBorrdData = (Response) => {
        if (Response.success) {
            setDashBoardCount(Response.data);
            FetchAlertInfo();
        }
        else {
            setDashBoardCount({});
        }

        setLoading(false);
    };

    const hidepopup = () => {
        setLicensePopup(null);
    }

    const Failure = (err) => {
        FailureAlert(err);
        setLoading(false);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show" style={{ border: "none", borderRadius: "0" }}>
                <div className="col-md-12" style={{ padding: "0", margin: "0" }}>
                    {Loading && (<Loader></Loader>)}
                    <main style={{ backgroundRepeat: "round", backgroundSize: "contain", backgroundImage: `url('${PickNTrackPattern}')` }}>

                        <section className="glass">
                            <div className="dashboard">
                                <div className="logoSection">
                                    <img width="120" height="60" alt="Welcome Icon" src={WelcomeIcon}></img>
                                </div>
                                <div className="appHeader">
                                    <div className="link">
                                        <span className={`${CurrentTheme}Color`} style={{ fontSize: "1.5rem", color: "#005582" }}><FontAwesomeIcon icon={faBoxOpen} /></span>
                                        <h4>Pack</h4>
                                    </div>
                                    <div className="link">
                                        <span className={`${CurrentTheme}Color`} style={{ fontSize: "1.4rem", color: "#005582" }}><FontAwesomeIcon icon={faTruck} /></span>
                                        <h4>Move</h4>
                                    </div>
                                    <div className="link">
                                        <span className={`${CurrentTheme}Color`} style={{ fontSize: "1.2rem", color: "#005582" }}><FontAwesomeIcon icon={faWarehouse} /></span>
                                        <h4>Store</h4>
                                    </div>
                                    <div className="link">
                                        <span className={`${CurrentTheme}Color`} style={{ fontSize: "1.2rem", color: "#005582" }}><FontAwesomeIcon icon={faMapMarkedAlt} /></span>
                                        <h4>Track</h4>
                                    </div>
                                </div>
                                <div className="trademark">
                                    <h4>MFIND</h4>
                                </div>
                            </div>
                            <div className="appInfo">
                                <div style={{ position: "relative" }} className="row d-flex justify-content-center status">
                                    <h3 className='col-md-11 col-10'>Hello, {Message} !!</h3>
                                    {PartnerAdminAlert.AlertDesc !== undefined && (<div className='col-md-1 col-1'><span title={`${(PartnerAdminAlert.AlertDesc !== undefined ? "New Notification from Admininstrator. Please check Dasboard page for more details." : "")}`} style={{
                                        position: "absolute", right: "10px", fontSize: "22px", backgroundColor: "rgba(55,125,255,.2)",
                                        height: "44px", borderRadius: "50%", padding: "5px 11px 10px 11px", color: "#377dff"
                                    }}>
                                        <FontAwesomeIcon icon={faBell}></FontAwesomeIcon>
                                        <span style={{
                                            width: "18px", height: "18px", borderRadius: "50%", display: "block",
                                            backgroundColor: "red", bottom: "38px", left: "16px", position: "relative",
                                            border: "3px solid white"
                                        }}></span>
                                    </span></div>)}

                                </div>
                                <div className="cards">
                                    <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Quotation</h4>
                                            <h6>Total Quotations created through Application.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2><CountUp start={0} duration={2} end={(DashBoardCount.QuotationCount ? DashBoardCount.QuotationCount : 0)}></CountUp></h2>
                                        </div>
                                    </div>
                                    {/* <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Invoice</h4>
                                            <h6>Total Invoices created through Application.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2><CountUp start={0} duration={2} end={DashBoardCount.InvoiceCount ? DashBoardCount.InvoiceCount : 0}></CountUp></h2>
                                        </div>
                                    </div> */}
                                    <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Members</h4>
                                            <h6>Total Members of Application.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2> <CountUp start={0} duration={2} end={(DashBoardCount.UsersCount ? DashBoardCount.UsersCount : 0)}></CountUp></h2>
                                        </div>
                                    </div>

                                    {/* <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Customers</h4>
                                            <h6>Total Customers attended.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2> <CountUp start={0} duration={2} end={DashBoardCount.CustomerCount ? DashBoardCount.CustomerCount : 0}></CountUp></h2>
                                        </div>
                                    </div> */}
                                    {/* <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Lorry Reciept</h4>
                                            <h6>Total LR created through Application.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2> <CountUp start={0} duration={2} end={DashBoardCount.LorryRecieptCount ? DashBoardCount.LorryRecieptCount : 0}></CountUp></h2>
                                        </div>
                                    </div> */}
                                    <div className="cardDiv">
                                        <div className="card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Tracking</h4>
                                            <h6>Total Active Trakings.</h6>
                                        </div>
                                        <div className="counter">
                                            <h6 style={{ textTransform: "uppercase" }}>Total</h6>
                                            <h2> <CountUp start={0} duration={2} end={(DashBoardCount.TrackCount ? DashBoardCount.TrackCount : 0)}></CountUp></h2>
                                        </div>
                                    </div>
                                    <div className="row cardDiv" style={{ justifyContent: "space-evenly" }}>
                                        <div className="col-md-2 col-6 card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Leads</h4>
                                            <h2> <CountUp start={0} duration={2} end={0}></CountUp></h2>
                                        </div>
                                        <div className="col-md-2 col-6 card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Quotes</h4>
                                            <h2> <CountUp start={0} duration={2} end={0}></CountUp></h2>
                                        </div>
                                        <div className="col-md-2 col-6 card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Pickup</h4>
                                            <h2> <CountUp start={0} duration={2} end={0}></CountUp></h2>
                                        </div>
                                        <div className="col-md-2 col-6 card-info">
                                            <h4 style={{ textTransform: "uppercase" }}>Delivery</h4>
                                            <h2> <CountUp start={0} duration={2} end={(DashBoardCount.DeliveryCount ? DashBoardCount.DeliveryCount : 0)}></CountUp></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="circle1">
                            <div className="iconMoveAnim" style={{ opacity: "0.8" }}>
                                <img alt="Truck" width="100%" src={TruckIcon}></img>
                            </div>
                        </div>
                        <div className="circle2">
                            <div className="iconMoveAnim" style={{ opacity: "0.8" }}>
                                <img alt="Pack" width="110%" src={CartonBox}></img>
                            </div>
                        </div>
                    </main>
                    {LicensePopup && LicensePopup <= 30 && (<div id="license" className="modal" style={{ display: "block" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className='text-center'>License Expiry Message</h4>
                                <span className="close" style={{ color: "black" }} onClick={hidepopup}>&times;</span>
                            </div>
                            <div className='text-center mt-4'>
                                <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: "5rem", color: "orange" }}></FontAwesomeIcon>
                                <h4 className='mt-2'>Your License in expiring soon !!</h4>
                                <h5 style={{ color: "red" }}>You have {LicensePopup} days left</h5>
                            </div>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>
    );
};

export default Welcome;